import { z } from 'zod';

export const optionalNumberInput = z.union([z.literal(''), z.number()]).optional();
